import React from "react";

const GlobalAlertSkeleton = () => {
  return (
    <div className="p-5 border border-[#EBEFF3] rounded-md bg-white animate-pulse">
    <div className="flex items-center justify-between pb-4 mb-4 border-b border-[#EBEFF3]">
      <div className="h-5 w-2/3 bg-gray-200 rounded"></div>
    </div>

    <div className="mb-5 space-y-2">
      <div className="h-4 w-full bg-gray-200 rounded"></div>
      <div className="h-4 w-5/6 bg-gray-200 rounded"></div>
      <div className="h-4 w-1/2 bg-gray-200 rounded"></div>
    </div>

    <div className="h-10 w-full bg-gray-200 rounded"></div>
  </div>
  );
};

export default GlobalAlertSkeleton;
